import { render, staticRenderFns } from "./SurgSpecialApproval.vue?vue&type=template&id=032e542d"
import script from "./SurgSpecialApproval.vue?vue&type=script&lang=js"
export * from "./SurgSpecialApproval.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports